import { useState, useEffect } from 'react';

interface UsePressedResponse {
  /** State to determine if the checkbox is pressed. */
  isPressed: boolean;
  /* Handler for mouse down event. */
  handleMouseDown: () => void;
}

/**
 * Custom hook to determine if an element is pressed.
 * It sets isPressed to true when mouse is down and resets when mouse is up.
 * It accounts for the scenario where mouse is released outside the element.
 */
export default function useIsPressed(): UsePressedResponse {
  const [isPressed, setIsPressed] = useState(false);

  const handleMouseDown = () => {
    setIsPressed(true);
  };

  // If the mouse is released outside of the element, reset isPressed state to false
  useEffect(() => {
    const handleMouseUp = () => {
      setIsPressed(false);
    };

    if (isPressed) {
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isPressed]);

  return {
    isPressed,
    handleMouseDown,
  };
}
